import { render, staticRenderFns } from "./PersonalMenu.vue?vue&type=template&id=4b8747fa&scoped=true&"
import script from "./PersonalMenu.vue?vue&type=script&lang=js&"
export * from "./PersonalMenu.vue?vue&type=script&lang=js&"
import style0 from "./PersonalMenu.vue?vue&type=style&index=0&id=4b8747fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8747fa",
  null
  
)

export default component.exports